module.exports = __webpack_public_path__ + "static/media/YM65_5.be1d1395.jpg";